import {PayProcessProvider} from '../../shared/nestjs/payroll/pay-process/pay-process';
import {CurrencyFormatterProvider} from '../currency-formatter/currency-formatter';
import {Injectable} from '@angular/core';
import async from 'async'
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class GdPayrollProvider {
  excelStyles: any;

  constructor(
    private translate: TranslateService,
    private currencyFormatterProvider: CurrencyFormatterProvider,
    private payProcessProvider: PayProcessProvider,
  ) {
    this.excelStyles = {
      'dhx_generated_class_u1545128180056': {
        'background': '#6A84DB !important',
        'color': '#FFFFFF',
        'text-align': 'center',
        'width': '250px',
        'text-transform': 'capitalize !important',
      },
      'dhx_generated_class_u1545128180058': {
        'color': '#e7a369',
        'text-align': 'center',
      },
      'dhx_generated_class_u1545128180057': {
        'color': '#00a9be',
        'text-align': 'center',
      },
      'black': {
        'color': '#58595B',
        'text-align': 'center',
      },
      'allowance': {
        'background': '#78CBBF !important',
        'color': '#FFFFFF !important',
        'text-align': 'center',
        'text-transform': 'capitalize !important',
        'width': '250px'
      },
      'deduction': {
        'background': '#F8C979 !important',
        'color': '#FFFFFF',
        'text-align': 'center',
        'text-transform': 'capitalize !important',
        'width': '250px'
      },
      'neutral': {
        'background': '#8d8d8d !important',
        'color': '#FFFFFF',
        'text-align': 'center',
        'text-transform': 'capitalize !important',
        'width': '250px'
      },
      'number-deduction': {
        'color': '#e7a369',
        'text-align': 'right',
      },
      'number-black': {
        'color': '#58595B',
        'text-align': 'right',
      },
    }
  }

  public getExcelDataID(periodCode, paydate, skip, limit): Promise<any> {
    return new Promise((res, rej) => {

      function idOf(i) {
        return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
      }

      let index = 0;
      let indexalphabet = 0;
      let dataemployee = [];
      let headerList = [{
        value: '',
        css: '',
      }];

      this.payProcessProvider.getReviewData(periodCode, paydate, skip, limit).subscribe(
        result => {

          if (result.notePrevProcess) {
            const returnData = {
              dataParse: {
                data: [],
                styles: this.excelStyles,
              },
              headerList: headerList,
              countEmployee: result.dataEmployee.length,
              totalEmployee: result.totalEmployee,
              totalPage: result.totalPage,
              isStop: true,
              stopMessage: result.notePrevProcess,
            };

            res(returnData)
            return;
          }

          for (let dataEmp of result.dataEmployee) {
            index++;


            if (index == 1) {
              indexalphabet = 0;

              headerList.push({
                value: 'Employee Name',
                css: 'dhx_generated_class_u1545128180056'
              })

              let empname = {
                'cell': 'A1',
                'value': '' + (dataEmp.first_name == 'null' || dataEmp.first_name == 'undefined' || dataEmp.first_name == undefined || dataEmp.first_name == null ? '' : dataEmp.first_name)
              };
              dataemployee.push(empname);
              async.eachOfSeries(
                dataEmp,
                (good, key, callback2) => {

                  let comp = key.split('_');
                  if (comp[0] == 'AL' || comp[0] == 'DE' || comp[0] == 'NE' || key == 'SALARY') {
                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    if (good.allowdeducttype == 'A') {
                      headerList.push({value: '+ ' + good.allowdeductname, css: 'allowance'});
                      let emp3 = {
                        'cell': cell1,
                        'css': 'number-black',
                        'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp3);
                    } else if (good.allowdeducttype == 'D') {
                      headerList.push({value: '- ' + good.allowdeductname, css: 'deduction'});
                      // dataemployee.push(emp2);
                      let emp3 = {
                        'cell': cell1,
                        'css': 'number-deduction',
                        'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp3);
                    } else {
                      headerList.push({value: '+ ' + good.allowdeductname, css: 'neutral'});

                      let emp3 = {
                        'cell': cell1,
                        'css': 'number-black',
                        'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp3);
                    }

                  } else if (key == 'tax_allowance') {
                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    headerList.push({value: '+ ' + 'Tax Allowance', css: 'allowance'});
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'total_allowance') {
                    let cell1 = '';

                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    headerList.push({value: '+ ' + 'Total Allowance', css: 'allowance'})
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'tax_deductions') {
                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;
                    headerList.push({value: '- ' + 'Tax Deductions', css: 'deduction'})
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'total_deductions') {
                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;
                    headerList.push({value: '- ' + 'Total Deductions', css: 'deduction'})
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'tax_penalty') {
                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;
                    headerList.push({value: '- ' + 'Tax Penalty', css: 'deduction'})
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'takeHomepay') {
                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;
                    headerList.push({value: 'Take Home Pay', css: 'allowance'})
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'tax_bornebycomp') {
                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;
                    headerList.push({value: '+ ' + 'Tax Borne By Comp', css: 'allowance'})
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'tax_Borned_By_Gov') {

                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    headerList.push({value: '+ ' + good.allowdeductname, css: 'allowance'});
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  }

                  callback2();
                }
              )

            } else {
              indexalphabet = 0

              let emp = {
                'cell': idOf(indexalphabet) + '' + (index),
                'value': '' + (dataEmp.first_name == 'null' || dataEmp.first_name == 'undefined' || dataEmp.first_name == undefined || dataEmp.first_name == null ? '' : dataEmp.first_name)
              };
              dataemployee.push(emp);

              async.eachOfSeries(
                dataEmp,
                (data, key, callback2) => {
                  let comp = key.split('_');

                  if (comp[0] == 'AL' || comp[0] == 'DE' || comp[0] == 'NE' || key == 'SALARY') {
                    let cell = '';
                    cell = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;
                    if (data.allowdeducttype == 'A') {
                      let emp2 = {
                        'cell': cell,
                        'css': 'number-black',
                        'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp2)
                    } else if (data.allowdeducttype == 'D') {
                      let emp2 = {
                        'cell': cell,
                        'css': 'number-deduction',
                        'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp2)
                    } else {
                      let emp2 = {
                        'cell': cell,
                        'css': 'number-black',
                        'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp2)
                    }


                  } else if (key == 'tax_allowance') {
                    let cell = '';
                    cell = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'total_allowance') {
                    let cell = '';
                    cell = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'tax_deductions') {
                    let cell = '';
                    cell = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    let emp3 = {
                      'cell': cell,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'total_deductions') {
                    let cell = '';
                    cell = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    let emp3 = {
                      'cell': cell,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'tax_penalty') {
                    let cell = '';
                    cell = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    let emp3 = {
                      'cell': cell,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'takeHomepay') {
                    let cell = '';
                    cell = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'tax_bornebycomp') {
                    let cell = '';
                    cell = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'tax_Borned_By_Gov') {
                    let cell1 = '';
                    cell1 = idOf(indexalphabet + 1) + '' + (index);
                    indexalphabet++;

                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  }

                  callback2();

                });
            }

          }
          let dataParse = {
            'data': dataemployee,
            'styles': this.excelStyles
          };

          let returnData = {
            dataParse: dataParse,
            headerList: headerList,
            countEmployee: result.dataEmployee.length,
            totalEmployee: result.totalEmployee,
            totalPage: result.totalPage,
          };

          res(returnData)
        },
        () => {
          rej(null)
        }
      )
    })


  }

  public getExcelDataMY(periodCode, paydate, skip, limit): Promise<any> {
    return new Promise((res, rej) => {

      let index = 0;
      let indexalphabet = 0;

      const dataemployee = [];
      const headerList = [{
        value: '',
        css: '',
      }];

      this.payProcessProvider.getReviewData(periodCode, paydate, skip, limit).subscribe(
        result => {

          if (result.notePrevProcess) {
            const returnData = {
              dataParse: {
                data: [],
                styles: this.excelStyles,
              },
              headerList: headerList,
              countEmployee: result.dataEmployee.length,
              totalEmployee: result.totalEmployee,
              totalPage: result.totalPage,
              isStop: true,
              stopMessage: result.notePrevProcess,
            };

            res(returnData)
            return;
          }

          for (const dataEmp of result.dataEmployee) {
            index++;

            if (index == 1) {
              indexalphabet = 0;

              headerList.push({
                value: 'Employee Name',
                css: 'dhx_generated_class_u1545128180056'
              })

              const empname = {
                cell: 'A1',
                value: '' + (dataEmp.first_name == 'null' || dataEmp.first_name == 'undefined' || dataEmp.first_name == undefined || dataEmp.first_name == null ? '' : dataEmp.first_name)
              };

              dataemployee.push(empname);
              async.eachOfSeries(
                dataEmp,
                (good, key, callback2) => {

                  if (key == 'tax_allowance') {

                    headerList.push({value: '+ ' + 'Tax Allowance', css: 'allowance'});
                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'total_allowance') {

                    headerList.push({value: '+ ' + 'Total Allowance', css: 'allowance'})
                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      code: key,
                      empId: dataEmp.empId,
                    });
                    indexalphabet++;

                  } else if (key == 'tax_deductions') {
                    headerList.push({value: '- ' + 'Tax Deductions', css: 'deduction'})

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-deduction',
                      value: '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'total_deductions') {
                    headerList.push({value: '- ' + 'Total Deductions', css: 'deduction'})
                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-deduction',
                      value: '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'tax_penalty') {
                    headerList.push({value: '- ' + 'Tax Penalty', css: 'deduction'})

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-deduction',
                      value: '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'takeHomepay') {
                    headerList.push({value: 'Take Home Pay', css: 'allowance'})

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'tax_bornebycomp') {
                    headerList.push({value: '+ ' + 'Tax Borne By Comp', css: 'allowance'})

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'tax_Borned_By_Gov') {
                    headerList.push({value: '+ ' + good.allowdeductname, css: 'allowance'});
                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else {

                    if (good.allowdeductname) {
                      const cell1 = this.idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                      if (good.allowdeducttype == 'A') {
                        headerList.push({value: '+ ' + good.allowdeductname, css: 'allowance'});
                        dataemployee.push({
                          cell: cell1,
                          css: 'number-black',
                          value: '' + this.transformer((good.formula_result == 'null' || good.formula_result == 'undefined' || good.formula_result == undefined || good.formula_result == null ? '' : good.formula_result)),
                          code: key,
                          empId: dataEmp.empId
                        });
                      } else if (good.allowdeducttype == 'D') {
                        headerList.push({value: '- ' + good.allowdeductname, css: 'deduction'});
                        dataemployee.push({
                          cell: cell1,
                          css: 'number-deduction',
                          value: '' + this.transformer((good.formula_result == 'null' || good.formula_result == 'undefined' || good.formula_result == undefined || good.formula_result == null ? '' : good.formula_result)),
                          code: key,
                          empId: dataEmp.empId
                        });
                      } else {
                        headerList.push({value: good.allowdeductname, css: 'neutral'});
                        dataemployee.push({
                          cell: cell1,
                          css: 'number-black',
                          value: '' + this.transformer((good.formula_result == 'null' || good.formula_result == 'undefined' || good.formula_result == undefined || good.formula_result == null ? '' : good.formula_result)),
                          code: key,
                          empId: dataEmp.empId
                        });
                      }
                    }
                  }

                  callback2();
                }
              )

            } else {
              indexalphabet = 0

              const emp = {
                cell: this.idOf(indexalphabet) + '' + (index),
                value: '' + (dataEmp.first_name == 'null' || dataEmp.first_name == 'undefined' || dataEmp.first_name == undefined || dataEmp.first_name == null ? '' : dataEmp.first_name)
              };

              dataemployee.push(emp);

              async.eachOfSeries(
                dataEmp,
                (data, key, callback2) => {

                  if (key == 'tax_allowance') {
                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'total_allowance') {

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'tax_deductions') {

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-deduction',
                      value: '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'total_deductions') {

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-deduction',
                      value: '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'tax_penalty') {

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-deduction',
                      value: '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'takeHomepay') {

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'tax_bornebycomp') {

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else if (key == 'tax_Borned_By_Gov') {

                    dataemployee.push({
                      cell: this.idOf(indexalphabet + 1) + '' + (index),
                      css: 'number-black',
                      value: '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      code: key,
                      empId: dataEmp.empId
                    });
                    indexalphabet++;

                  } else {

                    if (data.allowdeductname) {
                      const cell1 = this.idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                      if (data.allowdeducttype == 'A') {
                        dataemployee.push({
                          cell: cell1,
                          css: 'number-black',
                          value: '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                          code: key,
                          empId: dataEmp.empId
                        });
                      } else if (data.allowdeducttype == 'D') {
                        dataemployee.push({
                          cell: cell1,
                          css: 'number-deduction',
                          value: '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                          code: key,
                          empId: dataEmp.empId
                        });
                      } else {
                        dataemployee.push({
                          cell: cell1,
                          css: 'number-black',
                          value: '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                          code: key,
                          empId: dataEmp.empId
                        });
                      }
                    }

                  }

                  callback2();

                });
            }

          }

          const dataParse = {
            data: dataemployee,
            styles: this.excelStyles,
          };

          const returnData = {
            dataParse: dataParse,
            headerList: headerList,
            countEmployee: result.dataEmployee.length,
            totalEmployee: result.totalEmployee,
            totalPage: result.totalPage,
          };

          res(returnData)
        },
        () => {
          rej(null)
        }
      )
    })


  }

  public getExcelDataTH(periodCode, paydate, skip, limit): Promise<any> {
    return new Promise((res, rej) => {

      function idOf(i) {
        return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
      }

      let index = 0;
      let indexalphabet = 0;
      let dataemployee = [];
      let lockList = [];
      let headerList = [{
        value: '',
        css: '',
      }];


      this.payProcessProvider.getReviewData(periodCode, paydate, skip, limit).subscribe(result => {

          if (result.notePrevProcess) {
            const returnData = {
              dataParse: {
                data: [],
                styles: this.excelStyles,
              },
              headerList: headerList,
              countEmployee: result.dataEmployee.length,
              totalEmployee: result.totalEmployee,
              totalPage: result.totalPage,
              isStop: true,
              stopMessage: result.notePrevProcess,
            };

            res(returnData)
            return;
          }

          for (let dataEmp of result.dataEmployee) {
            index++;
            if (index == 1) {
              indexalphabet = 0;
              let indexchild = 0;
              headerList.push({
                value: 'Employee Name',
                css: 'dhx_generated_class_u1545128180056'
              });
              let empname = {
                'cell': 'A1',
                'value': '' + (dataEmp.first_name == 'null' || dataEmp.first_name == 'undefined' || dataEmp.first_name == undefined || dataEmp.first_name == null ? '' : dataEmp.first_name)
              };
              dataemployee.push(empname);
              lockList.push('A1');
              async.eachOfSeries(
                dataEmp,
                (good, key, callback2) => {

                  if (key == 'tax_allowance') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "+ " + "Tax Allowance", "css": "allowance", "code": key };
                    headerList.push({value: '+ ' + 'Tax Allowance', css: 'allowance'});
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'total_earnings') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "+ " + "Total Earnings", "css": "allowance", "code": key };
                    headerList.push({value: '+ ' + 'Total Earnings', css: 'allowance'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'total_deductions') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "- " + "Total Deductions", "css": "deduction", "code": key };
                    headerList.push({value: '- ' + 'Total Deductions', css: 'deduction'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'withholding_tax') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "- " + "Withholding Tax", "css": "deduction", "code": key };
                    headerList.push({value: '- ' + 'Withholding Tax', css: 'deduction'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'takeHomepay') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "" + "Net Pay", "css": "allowance", "code": key };
                    headerList.push({value: 'Net Pay', css: 'allowance'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'total_tax_income') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "" + "Total Taxable Income", "css": "dhx_generated_class_u1545128180056", "code": key };
                    headerList.push({value: 'Total Taxable Income', css: 'dhx_generated_class_u1545128180056'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'pf_employeeer') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "" + "PF - Employer", "css": "dhx_generated_class_u1545128180056", "code": key };
                    headerList.push({value: 'PF - Employer', css: 'dhx_generated_class_u1545128180056'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'bank_name') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "" + "Bank Name", "css": "dhx_generated_class_u1545128180056", "code": key };
                    headerList.push({value: 'Bank Name', css: 'dhx_generated_class_u1545128180056'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      // "css": "number-black",
                      'value': '' + (good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'bank_account') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "" + "Bank Account", "css": "dhx_generated_class_u1545128180056", "code": key };
                    headerList.push({value: 'Bank Account', css: 'dhx_generated_class_u1545128180056'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'black',
                      'value': '' + (good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);

                  } else if (key == 'PF_EMPLOYEE_RATE1') {
                    let cell1 = '';
                    if (indexalphabet > 24) {
                      cell1 = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell1 = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (good.editable == 'N') {
                      lockList.push(cell1)
                    }
                    // let emp2 = { "cell": cell1, "value": "" + "PF Employee Rate", "css": "dhx_generated_class_u1545128180056", "code": key };
                    headerList.push({value: 'PF Employee Rate', css: 'dhx_generated_class_u1545128180056'})
                    // dataemployee.push(emp2);
                    let emp3 = {
                      'cell': cell1,
                      'css': 'number-black',
                      'value': '' + this.transformer((good.totalval == 'null' || good.totalval == 'undefined' || good.totalval == undefined || good.totalval == null ? '' : good.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                    lockList.push(cell1);
                  } else {

                    if (good.allowdeductname) {
                      let cell1 = '';
                      if (indexalphabet > 24) {
                        cell1 = 'A' + idOf(indexchild) + '' + (index);
                        indexchild++;
                      } else {
                        cell1 = idOf(indexalphabet + 1) + '' + (index);
                        indexalphabet++;

                      }

                      if (good.editable == 'N') {
                        lockList.push(cell1)
                      }

                      if (good.allowdeducttype == 'A') {
                        headerList.push({value: '+ ' + good.allowdeductname, css: 'allowance'});
                        let emp3 = {
                          'cell': cell1,
                          'css': 'number-black',
                          'value': '' + this.transformer((good.formula_result == 'null' || good.formula_result == 'undefined' || good.formula_result == undefined || good.formula_result == null ? '' : good.formula_result)),
                          'code': key,
                          'empId': dataEmp.empId
                        };
                        dataemployee.push(emp3);
                      } else if (good.allowdeducttype == 'D') {
                        headerList.push({value: '- ' + good.allowdeductname, css: 'deduction'});
                        // dataemployee.push(emp2);
                        let emp3 = {
                          'cell': cell1,
                          'css': 'number-deduction',
                          'value': '' + this.transformer((good.formula_result == 'null' || good.formula_result == 'undefined' || good.formula_result == undefined || good.formula_result == null ? '' : good.formula_result)),
                          'code': key,
                          'empId': dataEmp.empId
                        };
                        dataemployee.push(emp3);
                      } else {
                        headerList.push({value: good.allowdeductname, css: 'neutral'});
                        // dataemployee.push(emp2);
                        let emp3 = {
                          'cell': cell1,
                          'css': 'number-black',
                          'value': '' + this.transformer((good.formula_result == 'null' || good.formula_result == 'undefined' || good.formula_result == undefined || good.formula_result == null ? '' : good.formula_result)),
                          'code': key,
                          'empId': dataEmp.empId
                        };
                        dataemployee.push(emp3);
                      }
                    }
                  }
                  callback2();
                }
              )

            } else {
              indexalphabet = 0

              let emp = {
                'cell': idOf(indexalphabet) + '' + (index),
                'value': '' + (dataEmp.first_name == 'null' || dataEmp.first_name == 'undefined' || dataEmp.first_name == undefined || dataEmp.first_name == null ? '' : dataEmp.first_name)
              };

              dataemployee.push(emp);
              lockList.push(idOf(indexalphabet) + '' + (index));
              let indexchild = 0;

              async.eachOfSeries(
                dataEmp,
                (data, key, callback2) => {
                  let comp = key.split('_');


                  if (comp[0] == 'AL' || comp[0] == 'DE' || key == 'SALARY' || key == 'PROVIDENT' || key == 'SOCIALINS') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }

                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }

                    if (data.allowdeducttype == 'A') {
                      let emp2 = {
                        'cell': cell,
                        'css': 'number-black',
                        'value': '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp2)
                    } else if (data.allowdeducttype == 'D') {
                      let emp2 = {
                        'cell': cell,
                        'css': 'number-deduction',
                        'value': '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp2)
                    } else {
                      let emp2 = {
                        'cell': cell,
                        'css': 'number-black',
                        'value': '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                        'code': key,
                        'empId': dataEmp.empId
                      };
                      dataemployee.push(emp2)
                    }


                  } else if (key == 'tax_allowance') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;

                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'total_deductions') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'withholding_tax') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-deduction',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'total_earnings') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else if (key == 'takeHomepay') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'total_tax_income') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'pf_employeeer') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'bank_name') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      // "css": "number-black",
                      'value': '' + (data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'bank_account') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'black',
                      'value': '' + (data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);

                  } else if (key == 'PF_EMPLOYEE_RATE1') {
                    let cell = '';
                    if (indexalphabet > 24) {
                      cell = 'A' + idOf(indexchild) + '' + (index);
                      indexchild++;
                    } else {
                      cell = idOf(indexalphabet + 1) + '' + (index);
                      indexalphabet++;
                    }
                    if (data.editable == 'N') {
                      lockList.push(cell)
                    }
                    let emp3 = {
                      'cell': cell,
                      'css': 'number-black',
                      'value': '' + this.transformer((data.totalval == 'null' || data.totalval == 'undefined' || data.totalval == undefined || data.totalval == null ? '' : data.totalval)),
                      'code': key,
                      'empId': dataEmp.empId
                    };
                    dataemployee.push(emp3);
                  } else {
                    if (data.allowdeductname) {
                      let cell = '';
                      if (indexalphabet > 24) {
                        cell = 'A' + idOf(indexchild) + '' + (index);
                        indexchild++;
                      } else {
                        cell = idOf(indexalphabet + 1) + '' + (index);
                        indexalphabet++;

                      }

                      if (data.editable == 'N') {
                        lockList.push(cell)
                      }

                      if (data.allowdeducttype == 'A') {
                        let emp2 = {
                          'cell': cell,
                          'css': 'number-black',
                          'value': '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                          'code': key,
                          'empId': dataEmp.empId
                        };
                        dataemployee.push(emp2)
                      } else if (data.allowdeducttype == 'D') {
                        let emp2 = {
                          'cell': cell,
                          'css': 'number-deduction',
                          'value': '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                          'code': key,
                          'empId': dataEmp.empId
                        };
                        dataemployee.push(emp2)
                      } else {
                        let emp2 = {
                          'cell': cell,
                          'css': 'number-black',
                          'value': '' + this.transformer((data.formula_result == 'null' || data.formula_result == 'undefined' || data.formula_result == undefined || data.formula_result == null ? '' : data.formula_result)),
                          'code': key,
                          'empId': dataEmp.empId
                        };
                        dataemployee.push(emp2)
                      }
                    }
                  }

                  callback2();

                });
            }

          }
          let dataParse = {
            'data': dataemployee,
            'styles': this.excelStyles
          };

          let returnData = {
            dataParse: dataParse,
            lockList: lockList,
            headerList: headerList,
            countEmployee: result.dataEmployee.length,
            totalEmployee: result.totalEmployee,
            totalPage: result.totalPage,
          };
          res(returnData)
        },
        () => {
          rej(null)
        }
      )
    })


  }

  public getEmpPayrollDataTH(result): Promise<any> {
    return new Promise(async (res) => {
      let index = 0;
      const dataemployee = [];
      const lockList = [];
      const headerList = [{
        value: '',
        css: '',
      }];

      result.sort((a, b) => (a.emp_id == null ? '' : a.emp_id).localeCompare(b.emp_id == null ? '' : b.emp_id));

      headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'});

      // LOOP PAYROLL INFO
      for (const a of result) {
        index++;
        let indexalphabet = 0;
        if (index == 1) {

          headerList.push({
            value: this.translate.instant('Bank Code'),
            css: 'dhx_generated_class_u1545128180056',
          });
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.bankCode == 'null' || a.bankCode == 'undefined' || a.bankCode == undefined || a.bankCode == null ? '' : a.bankCode),
            code: 'bankCode',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({
            value: this.translate.instant('Bank\'s Account Number'),
            css: 'dhx_generated_class_u1545128180056'
          });
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.bankAccount == 'null' || a.bankAccount == 'undefined' || a.bankAccount == undefined || a.bankAccount == null ? '' : a.bankAccount),
            code: 'bankAccount',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({
            value: this.translate.instant('Bank\'s Account Name'),
            css: 'dhx_generated_class_u1545128180056'
          });
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.bankName == 'null' || a.bankName == 'undefined' || a.bankName == undefined || a.bankName == null ? '' : a.bankName),
            code: 'bankName',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({
            value: this.translate.instant('SSO Number'),
            css: 'dhx_generated_class_u1545128180056',
          });
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.insuranceNo == 'null' || a.insuranceNo == 'undefined' || a.insuranceNo == undefined || a.insuranceNo == null ? '' : a.insuranceNo),
            code: 'insuranceNo',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({
            value: this.translate.instant('SSO Branch Code'),
            css: 'dhx_generated_class_u1545128180056'
          });
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.ssobranchCode == 'null' || a.ssobranchCode == 'undefined' || a.ssobranchCode == undefined || a.ssobranchCode == null ? '' : a.ssobranchCode),
            code: 'ssobranchCode',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({
            value: this.translate.instant('Tax File Number'),
            css: 'dhx_generated_class_u1545128180056'
          });
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.taxfilenumber == 'null' || a.taxfilenumber == 'undefined' || a.taxfilenumber == undefined || a.taxfilenumber == null ? '' : a.taxfilenumber),
            code: 'taxfilenumber',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({value: this.translate.instant('Tax Status'), css: 'dhx_generated_class_u1545128180056'});
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.taxstatus == 'null' || a.taxstatus == 'undefined' || a.taxstatus == undefined || a.taxstatus == null ? '' : a.taxstatus),
            code: 'taxstatus',
            empId: a.emp_id,
          });
          indexalphabet++;


          headerList.push({
            value: this.translate.instant('PF Employee Rate'),
            css: 'dhx_generated_class_u1545128180056'
          });
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.percentageEPF == 'null' || a.percentageEPF == 'undefined' || a.percentageEPF == undefined || a.percentageEPF == null ? '' : a.percentageEPF),
            code: 'percentageEPF',
            empId: a.emp_id,
          });
          indexalphabet++;


          headerList.push({value: this.translate.instant('Tax Type'), css: 'dhx_generated_class_u1545128180056'});
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.taxType == 'null' || a.taxType == 'undefined' || a.taxType == undefined || a.taxType == null ? '' : a.taxType),
            code: 'taxType',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({value: this.translate.instant('PF'), css: 'dhx_generated_class_u1545128180056'});
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.PF == 'null' || a.PF == 'undefined' || a.PF == undefined || a.PF == null ? '' : a.PF),
            code: 'PF',
            empId: a.emp_id,
          });
          indexalphabet++;


          headerList.push({value: this.translate.instant('PF Join Date'), css: 'dhx_generated_class_u1545128180056'});
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.joinDt == 'null' || a.joinDt == 'undefined' || a.joinDt == undefined || a.joinDt == null ? '' : a.joinDt),
            code: 'joinDt',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({value: this.translate.instant('PF End Date'), css: 'dhx_generated_class_u1545128180056'});
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.endDt == 'null' || a.endDt == 'undefined' || a.endDt == undefined || a.endDt == null ? '' : a.endDt),
            code: 'endDt',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({value: this.translate.instant('SSO'), css: 'dhx_generated_class_u1545128180056'});
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.SSO == 'null' || a.SSO == 'undefined' || a.SSO == undefined || a.SSO == null ? '' : a.SSO),
            code: 'SSO',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({value: this.translate.instant('Type SSO'), css: 'dhx_generated_class_u1545128180056'});
          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.typeSSO == 'null' || a.typeSSO == 'undefined' || a.typeSSO == undefined || a.typeSSO == null ? '' : a.typeSSO),
            code: 'typeSSO',
            empId: a.emp_id
          });
          indexalphabet++;


          headerList.push({value: this.translate.instant('Hospital Name'), css: 'dhx_generated_class_u1545128180056'});
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.hospitalName == 'null' || a.hospitalName == 'undefined' || a.hospitalName == undefined || a.hospitalName == null ? '' : a.hospitalName),
            code: 'hospitalName',
            empId: a.emp_id
          });
          indexalphabet++;

          dataemployee.push({
            cell: 'A' + (index),
            value: '' + (a.fullName == 'null' || a.fullName == 'undefined' || a.fullName == undefined || a.fullName == null ? '' : a.fullName),
            code: 'empId',
            empId: a.emp_id
          });
          lockList.push('A' + (index))

        } else {

          lockList.push('A' + (index))
          dataemployee.push({
            cell: 'A' + (index),
            value: '' + (a.fullName == 'null' || a.fullName == 'undefined' || a.fullName == undefined || a.fullName == null ? '' : a.fullName),
            code: 'empId',
            empId: a.emp_id
          });

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.bankCode == 'null' || a.bankCode == 'undefined' || a.bankCode == undefined || a.bankCode == null ? '' : a.bankCode),
            code: 'bankCode',
            empId: a.emp_id
          });
          indexalphabet++;

          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.bankAccount == 'null' || a.bankAccount == 'undefined' || a.bankAccount == undefined || a.bankAccount == null ? '' : a.bankAccount),
            code: 'bankAccount',
            empId: a.emp_id
          });
          indexalphabet++;

          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.bankName == 'null' || a.bankName == 'undefined' || a.bankName == undefined || a.bankName == null ? '' : a.bankName),
            code: 'bankName',
            empId: a.emp_id
          });
          indexalphabet++;

          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.insuranceNo == 'null' || a.insuranceNo == 'undefined' || a.insuranceNo == undefined || a.insuranceNo == null ? '' : a.insuranceNo),
            code: 'insuranceNo',
            empId: a.emp_id
          });
          indexalphabet++;

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.ssobranchCode == 'null' || a.ssobranchCode == 'undefined' || a.ssobranchCode == undefined || a.ssobranchCode == null ? '' : a.ssobranchCode),
            code: 'ssobranchCode',
            empId: a.emp_id
          });
          indexalphabet++;

          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.taxfilenumber == 'null' || a.taxfilenumber == 'undefined' || a.taxfilenumber == undefined || a.taxfilenumber == null ? '' : a.taxfilenumber),
            code: 'taxfilenumber',
            empId: a.emp_id
          });
          indexalphabet++;

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.taxstatus == 'null' || a.taxstatus == 'undefined' || a.taxstatus == undefined || a.taxstatus == null ? '' : a.taxstatus),
            code: 'taxstatus',
            empId: a.emp_id
          });
          indexalphabet++;

          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.percentageEPF == 'null' || a.percentageEPF == 'undefined' || a.percentageEPF == undefined || a.percentageEPF == null ? '' : a.percentageEPF),
            code: 'percentageEPF',
            empId: a.emp_id
          });
          indexalphabet++;

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.taxType == 'null' || a.taxType == 'undefined' || a.taxType == undefined || a.taxType == null ? '' : a.taxType),
            code: 'taxType',
            empId: a.emp_id
          });
          indexalphabet++;

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.PF == 'null' || a.PF == 'undefined' || a.PF == undefined || a.PF == null ? '' : a.PF),
            code: 'PF',
            empId: a.emp_id,
          });
          indexalphabet++;

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.joinDt == 'null' || a.joinDt == 'undefined' || a.joinDt == undefined || a.joinDt == null ? '' : a.joinDt),
            code: 'joinDt',
            empId: a.emp_id
          });
          indexalphabet++;

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.endDt == 'null' || a.endDt == 'undefined' || a.endDt == undefined || a.endDt == null ? '' : a.endDt),
            code: 'endDt',
            empId: a.emp_id
          });
          indexalphabet++;

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.SSO == 'null' || a.SSO == 'undefined' || a.SSO == undefined || a.SSO == null ? '' : a.SSO),
            code: 'SSO',
            empId: a.emp_id
          });
          indexalphabet++;

          lockList.push(this.idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.typeSSO == 'null' || a.typeSSO == 'undefined' || a.typeSSO == undefined || a.typeSSO == null ? '' : a.typeSSO),
            code: 'typeSSO',
            empId: a.emp_id
          });
          indexalphabet++;

          dataemployee.push({
            cell: this.idOf(indexalphabet + 1) + '' + (index),
            css: 'black',
            value: '' + (a.hospitalName == 'null' || a.hospitalName == 'undefined' || a.hospitalName == undefined || a.hospitalName == null ? '' : a.hospitalName),
            code: 'hospitalName',
            empId: a.emp_id
          });

        }
      }

      const dataParse = {
        data: dataemployee,
        styles: this.excelStyles,
      }

      const returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      }

      res(returnData)
    })
  }

  public getEmpTaxDeductionTHNew(result): Promise<any> {
    return new Promise((res) => {
      let index = 0;
      let dataemployee = [];
      let lockList = [];
      let headerList = [{
        value: '',
        css: '',
      }];

      function idOf(i) {
        return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
      }

      result.sort((a, b) => (a.emp_id == null ? '' : a.emp_id).localeCompare(b.emp_id == null ? '' : b.emp_id));

      headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'});
      lockList.push('A1');

      for (let a of result) {
        index++;
        let indexalphabet = 0;
        if (index == 1) {

          for (let comp of a.listTaxDeduct) {

            headerList.push({value: '' + comp.name, css: 'dhx_generated_class_u1545128180056'});
            let empdata2 = {
              'cell': idOf(indexalphabet + 1) + '' + (index),
              'css': comp.valueType == 'MONEY' ? 'number-black' : 'black',
              'value': '' +
              comp.valueType == 'MONEY' ?
                this.transformer((comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value)) :
                comp.valueType == 'NUMBER' ?
                  this.converToNumber((comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value)) :
                  (comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value),
              'code': '' + comp.code,
              'empId': a.emp_id
            };
            dataemployee.push(empdata2);
            if (
              comp.valueType == 'OPTIONS' ||
              comp.valueType == 'YESNO' ||
              comp.valueType == 'DATE'
            ) lockList.push(idOf(indexalphabet + 1) + '' + (index));
            indexalphabet++;

          }

          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

        } else {

          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

          for (let comp of a.listTaxDeduct) {

            let empdata2 = {
              'cell': idOf(indexalphabet + 1) + '' + (index),
              'css': comp.valueType == 'MONEY' ? 'number-black' : 'black',
              'value': '' +
              comp.valueType == 'MONEY' ?
                this.transformer((comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value)) :
                comp.valueType == 'NUMBER' ?
                  this.converToNumber((comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value)) :
                  (comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value),
              'code': '' + comp.code,
              'empId': a.emp_id,
            };
            dataemployee.push(empdata2);
            if (
              comp.valueType == 'OPTIONS' ||
              comp.valueType == 'YESNO' ||
              comp.valueType == 'DATE'
            ) lockList.push(idOf(indexalphabet + 1) + '' + (index));
            indexalphabet++;

          }

        }

      }
      let dataParse = {
        'data': dataemployee,
        'styles': this.excelStyles,
      }

      let returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      }

      res(returnData);
    })
  }

  public getEmpPayrollDataSalary(result): Promise<any> {
    return new Promise(async (res) => {
      let index = 0;
      let dataemployee = [];
      let lockList = [];
      let headerList = [{
        value: '',
        css: '',
      }];

      function idOf(i) {
        return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
      }

      result.sort((a, b) => (a.fullName == null ? '' : a.fullName).localeCompare(b.fullName == null ? '' : b.fullName));

      // let headerEmp1 = { "cell": "A1", "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Employee") };
      headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'});
      lockList.push('A1')

      // dataemployee.push(headerEmp1);


      // LOOP SALARY
      for (let a of result) {
        index++;
        let indexalphabet = 0;
        if (index == 1) {

          for (let comp of a.listcomponent) {
            if (comp.baseValue == 'N') {
              continue;
            }

            // let splitter = comp.allowdeduct_code.split('_');

            if (comp.allowdeducttype == 'A') {
              headerList.push({value: '+ ' + comp.allowdeductname, css: 'allowance'});
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else if (comp.allowdeducttype == 'D') {
              headerList.push({value: '- ' + comp.allowdeductname, css: 'deduction'});
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-deduction',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else {
              headerList.push({value: '' + comp.allowdeductname, css: 'neutral'});
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            }

          }

          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

        } else {
          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index));

          for (let comp of a.listcomponent) {
            if (comp.baseValue == 'N') {
              continue;
            }

            // let splitter = comp.allowdeduct_code.split('_');

            if (comp.allowdeducttype == 'A') {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else if (comp.allowdeducttype == 'D') {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-deduction',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            }

          }

        }

      }
      const dataParse = {
        'data': dataemployee,
        'styles': this.excelStyles,
      };

      const returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      };

      res(returnData)
    })

  }

  public getEmpPayrollDataSalaryFormula(result): Promise<any> {
    return new Promise(async (res) => {
      let index = 0;
      let dataemployee = [];
      let lockList = [];
      let headerList = [{
        value: '',
        css: '',
      }];

      function idOf(i) {
        return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
      }

      result.sort((a, b) => (a.fullName == null ? '' : a.fullName).localeCompare(b.fullName == null ? '' : b.fullName));

      // let headerEmp1 = { "cell": "A1", "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Employee") };
      headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'});
      lockList.push('A1')

      // dataemployee.push(headerEmp1);


      // LOOP SALARY
      for (let a of result) {
        index++;
        let indexalphabet = 0;
        if (index == 1) {

          for (let comp of a.listcomponent) {
            let splitter = comp.allowdeduct_code.split('_');


            if (splitter[0] == 'AL' || comp.allowdeduct_code == 'SALARY') {
              // let headerEmp2 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "allowance", "value": "+ " + comp.allowdeductname, "code": "" + comp.allowdeduct_code };
              headerList.push({value: '+ ' + comp.allowdeductname, css: 'allowance'});
              // dataemployee.push(headerEmp2);
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              // lockList.push(idOf(indexalphabet + 1) + "" + index)
              indexalphabet++;
            } else if (splitter[0] == 'DE') {
              // let headerEmp2 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "deduction", "value": "- " + comp.allowdeductname, "code": "" + comp.allowdeduct_code };
              headerList.push({value: '- ' + comp.allowdeductname, css: 'deduction'});
              // dataemployee.push(headerEmp2);
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-deduction',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              // lockList.push(idOf(indexalphabet + 1) + "" + index)
              indexalphabet++;
            } else {
              // let headerEmp2 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": "" + comp.allowdeductname, "code": "" + comp.allowdeduct_code };
              headerList.push({value: '' + comp.allowdeductname, css: 'dhx_generated_class_u1545128180056'})
              // dataemployee.push(headerEmp2);
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              // lockList.push(idOf(indexalphabet + 1) + "" + index)
              indexalphabet++;
            }
          }

          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

        } else {
          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

          for (let comp of a.listcomponent) {
            let splitter = comp.allowdeduct_code.split('_');

            if (splitter[0] == 'AL' || comp.allowdeduct_code == 'SALARY') {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else if (splitter[0] == 'DE') {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-deduction',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            }

          }

        }

      }
      let dataParse = {
        'data': dataemployee,
        'styles': this.excelStyles
      }

      let returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      }

      res(returnData)
    })

  }

  public getEmpPayrollDataSalaryTH(result): Promise<any> {
    return new Promise(async (res) => {
      let index = 0;
      let dataemployee = [];
      let lockList = [];
      let headerList = [{
        value: '',
        css: '',
      }];

      function idOf(i) {
        return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
      }

      result.sort((a, b) => (a.emp_id == null ? '' : a.emp_id).localeCompare(b.emp_id == null ? '' : b.emp_id));

      // let headerEmp1 = { "cell": "A1", "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Employee") };
      headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'})
      lockList.push('A1')

      // dataemployee.push(headerEmp1);


      // LOOP SALARY
      for (let a of result) {
        index++;
        let indexalphabet = 0;
        if (index == 1) {

          for (let comp of a.listcomponent) {
            if (comp.baseValue == 'N') {
              continue;
            }

            // let splitter = comp.allowdeduct_code.split('_');
            if (comp.allowdeducttype == 'A') {
              headerList.push({value: '+ ' + comp.allowdeductname, css: 'allowance'});
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else if (comp.allowdeducttype == 'D') {
              headerList.push({value: '- ' + comp.allowdeductname, css: 'deduction'});
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-deduction',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else {
              headerList.push({value: '' + comp.allowdeductname, css: 'neutral'});
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            }
          }

          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

        } else {
          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

          for (let comp of a.listcomponent) {
            if (comp.baseValue == 'N') {
              continue;
            }

            // let splitter = comp.allowdeduct_code.split('_');

            if (comp.allowdeducttype == 'A') {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else if (comp.allowdeducttype == 'D') {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-deduction',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.base_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            }

          }

        }

      }
      let dataParse = {
        'data': dataemployee,
        'styles': this.excelStyles
      }

      let returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      }

      res(returnData)
    })

  }

  public getEmpPayrollDataSalaryFormulaTH(result): Promise<any> {
    return new Promise(async (res) => {
      let index = 0;
      let dataemployee = [];
      let lockList = [];
      let headerList = [{
        value: '',
        css: '',
      }];

      function idOf(i) {
        return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
      }

      result.sort((a, b) => (a.emp_id == null ? '' : a.emp_id).localeCompare(b.emp_id == null ? '' : b.emp_id));

      // let headerEmp1 = { "cell": "A1", "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Employee") };
      headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'})
      lockList.push('A1')

      // dataemployee.push(headerEmp1);


      // LOOP SALARY
      for (let a of result) {
        index++;
        let indexalphabet = 0;
        if (index == 1) {

          for (let comp of a.listcomponent) {
            let splitter = comp.allowdeduct_code.split('_');


            if (splitter[0] == 'AL' || comp.allowdeduct_code == 'SALARY') {
              // let headerEmp2 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "allowance", "value": "+ " + comp.allowdeductname, "code": "" + comp.allowdeduct_code };
              // dataemployee.push(headerEmp2);
              headerList.push({value: '+ ' + comp.allowdeductname, css: 'allowance'})
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              // lockList.push(idOf(indexalphabet + 1) + "" + index)
              indexalphabet++;
            } else if (splitter[0] == 'DE') {
              // let headerEmp2 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "deduction", "value": "- " + comp.allowdeductname, "code": "" + comp.allowdeduct_code };
              // dataemployee.push(headerEmp2);
              headerList.push({value: '- ' + comp.allowdeductname, css: 'deduction'})
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-deduction',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              // lockList.push(idOf(indexalphabet + 1) + "" + index)
              indexalphabet++;
            } else {
              // let headerEmp2 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": "" + comp.allowdeductname, "code": "" + comp.allowdeduct_code };
              // dataemployee.push(headerEmp2);
              headerList.push({value: '' + comp.allowdeductname, css: 'dhx_generated_class_u1545128180056'})
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              // lockList.push(idOf(indexalphabet + 1) + "" + index)
              indexalphabet++;
            }
          }

          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

        } else {
          let empdata1 = {'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id};
          dataemployee.push(empdata1);
          lockList.push('A' + (index))

          for (let comp of a.listcomponent) {
            let splitter = comp.allowdeduct_code.split('_');

            if (splitter[0] == 'AL' || comp.allowdeduct_code == 'SALARY') {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else if (splitter[0] == 'DE') {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-deduction',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            } else {
              let empdata2 = {
                'cell': idOf(indexalphabet + 1) + '' + (index),
                'css': 'number-black',
                'value': '' + await this.currencyFormatterProvider.transform(comp.formula_result),
                'code': '' + comp.allowdeduct_code,
                'empId': a.emp_id
              };
              dataemployee.push(empdata2);
              indexalphabet++;
            }

          }

        }

      }
      let dataParse = {
        'data': dataemployee,
        'styles': this.excelStyles
      }

      let returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      }

      res(returnData)
    })

  }

  public getEmpPayrollDataID(result, param): Promise<any> {
    return new Promise(res => {
      let index = 0;
      let dataemployee = [];
      let lockList = [];
      let headerList = [{
        value: '',
        css: '',
      }];

      function idOf(i) {
        return (i >= 26 ? idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
      }

      result.sort((a, b) => (a.fullName == null ? '' : a.fullName).localeCompare(b.fullName == null ? '' : b.fullName));

      // let headerEmp1 = { "cell": "A1", "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Employee") };
      headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'});

      // dataemployee.push(headerEmp1);
      // lockList.push('A1')

      // LOOP PAYROLL INFO
      for (let a of result) {

        index++;
        let indexalphabet = 0;

        if (index == 1) {

          // let headerEmp3 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Bank Code") };
          headerList.push({value: this.translate.instant('Bank Code'), css: 'dhx_generated_class_u1545128180056'});
          // dataemployee.push(headerEmp3);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata3 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.bank_code == 'null' || a.bank_code == 'undefined' || a.bank_code == undefined || a.bank_code == null ? '' : a.bank_code),
            'code': 'bank_code',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index));
          dataemployee.push(empdata3);
          indexalphabet++;


          // let headerEmp4 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Bank's Account Number") };
          headerList.push({
            value: this.translate.instant('Bank\'s Account Number'),
            css: 'dhx_generated_class_u1545128180056'
          })
          // dataemployee.push(headerEmp4);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata4 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.bank_account == 'null' || a.bank_account == 'undefined' || a.bank_account == undefined || a.bank_account == null ? '' : a.bank_account),
            'code': 'bank_account',
            'empId': a.emp_id
          };
          dataemployee.push(empdata4);
          indexalphabet++;


          // let headerEmp5 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Bank's Account Name") };
          headerList.push({
            value: this.translate.instant('Bank\'s Account Name'),
            css: 'dhx_generated_class_u1545128180056'
          })
          // dataemployee.push(headerEmp5);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata6 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.account_name == 'null' || a.account_name == 'undefined' || a.account_name == undefined || a.account_name == null ? '' : a.account_name),
            'code': 'account_name',
            'empId': a.emp_id
          };
          dataemployee.push(empdata6);
          indexalphabet++;


          // let headerEmp6 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("BPJS Number") };
          headerList.push({value: this.translate.instant('BPJS Number'), css: 'dhx_generated_class_u1545128180056'})
          // dataemployee.push(headerEmp6);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata5 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.bpjs == 'null' || a.bpjs == 'undefined' || a.bpjs == undefined || a.bpjs == null ? '' : a.bpjs),
            'code': 'bpjs',
            'empId': a.emp_id
          };
          dataemployee.push(empdata5);
          indexalphabet++;


          // let headerEmp7 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Jamsostek Number") };
          headerList.push({
            value: this.translate.instant('Jamsostek Number'),
            css: 'dhx_generated_class_u1545128180056'
          })
          // dataemployee.push(headerEmp7);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata7 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.jamsostek == 'null' || a.jamsostek == 'undefined' || a.jamsostek == undefined || a.jamsostek == null ? '' : a.jamsostek),
            'code': 'jamsostek',
            'empId': a.emp_id
          };
          dataemployee.push(empdata7);
          indexalphabet++;


          // let headerEmp8 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("NPWP Number") };
          headerList.push({value: this.translate.instant('NPWP Number'), css: 'dhx_generated_class_u1545128180056'})
          // dataemployee.push(headerEmp8);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata8 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.taxfilenumber == 'null' || a.taxfilenumber == 'undefined' || a.taxfilenumber == undefined || a.taxfilenumber == null ? '' : a.taxfilenumber),
            'code': 'taxfilenumber',
            'empId': a.emp_id
          };
          dataemployee.push(empdata8);
          indexalphabet++;


          // let headerEmp9 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Tax Type") };
          headerList.push({value: this.translate.instant('Tax Type'), css: 'dhx_generated_class_u1545128180056'})
          // dataemployee.push(headerEmp9);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata9 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.tax_type == 'null' || a.tax_type == 'undefined' || a.tax_type == undefined || a.tax_type == null ? '' : a.tax_type),
            'code': 'tax_type',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata9);
          indexalphabet++;


          // let headerEmp10 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Tax Status") };
          headerList.push({value: this.translate.instant('Tax Status'), css: 'dhx_generated_class_u1545128180056'})
          // dataemployee.push(headerEmp10);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata10 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + ((a.taxstatus == 1 ? 'K' : 'TK') + (a.numdependent ? a.numdependent : 0)),
            'code': 'taxstatus',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata10);
          indexalphabet++;

          if (param == 0) {
            // let headerEmp10 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Tax Status") };
            headerList.push({
              value: this.translate.instant('Tax Borne By Comp Dec'),
              css: 'dhx_generated_class_u1545128180056'
            })
            // dataemployee.push(headerEmp10);
            // lockList.push(idOf(indexalphabet + 1) + "" + index)
            let empdata10 = {
              'cell': idOf(indexalphabet + 1) + '' + (index),
              'css': 'black',
              'value': '' + (a.taxbornebycompDec == 'null' || a.taxbornebycompDec == 'undefined'
              || a.taxbornebycompDec == undefined || a.taxbornebycompDec == null ? '' : a.taxbornebycompDec),
              'code': 'taxbornebycompDec',
              'empId': a.emp_id
            };
            // lockList.push(idOf(indexalphabet + 1) + "" + (index))
            dataemployee.push(empdata10);
            indexalphabet++;
          }

          // let headerEmp11 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": "JKM/JKK/JHT" };
          headerList.push({value: 'JKM/JKK/JHT', css: 'dhx_generated_class_u1545128180056'})
          // dataemployee.push(headerEmp11);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata11 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.tk == 'null' || a.tk == 'undefined' || a.tk == undefined || a.tk == null ? '' : a.tk),
            'code': 'tk',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata11);
          indexalphabet++;

          // let headerEmp11 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": "JKM/JKK/JHT" };
          headerList.push({value: 'JHT Allowance', css: 'dhx_generated_class_u1545128180056'})
          // dataemployee.push(headerEmp11);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          empdata11 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.saljht == 'null' || a.saljht == 'undefined' || a.saljht == undefined || a.saljht == null ? '' : a.saljht),
            'code': 'saljht',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index));
          dataemployee.push(empdata11);
          indexalphabet++;

          // let headerEmp12 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Jaminan Pensiun") };
          headerList.push({value: this.translate.instant('Jaminan Pensiun'), css: 'dhx_generated_class_u1545128180056'})
          // dataemployee.push(headerEmp12);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata12 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.jp == 'null' || a.jp == 'undefined' || a.jp == undefined || a.jp == null ? '' : a.jp),
            'code': 'jp',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata12);
          indexalphabet++;

          // let headerEmp12 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Jaminan Pensiun") };
          headerList.push({value: 'JP Allowance', css: 'dhx_generated_class_u1545128180056'})
          // dataemployee.push(headerEmp12);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          empdata12 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.saljp == 'null' || a.saljp == 'undefined' || a.saljp == undefined || a.saljp == null ? '' : a.saljp),
            'code': 'saljp',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata12);
          indexalphabet++;

          // let headerEmp13 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Jaminan Kesehatan") };
          headerList.push({
            value: this.translate.instant('Jaminan Kesehatan'),
            css: 'dhx_generated_class_u1545128180056'
          })
          // dataemployee.push(headerEmp13);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          let empdata13 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.ks == 'null' || a.ks == 'undefined' || a.ks == undefined || a.ks == null ? '' : a.ks),
            'code': 'ks',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata13);
          indexalphabet++;

          // let headerEmp13 = { "cell": idOf(indexalphabet + 1) + "" + index, "css": "dhx_generated_class_u1545128180056", "value": this.translate.instant("Jaminan Kesehatan") };
          headerList.push({
            value: this.translate.instant('KS Allowance'),
            css: 'dhx_generated_class_u1545128180056'
          })
          // dataemployee.push(headerEmp13);
          // lockList.push(idOf(indexalphabet + 1) + "" + index)
          empdata13 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.salks == 'null' || a.salks == 'undefined' || a.salks == undefined || a.salks == null ? '' : a.salks),
            'code': 'salks',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata13);
          indexalphabet++;

          headerList.push({
              value: this.translate.instant('Paythrough Date'),
              css: 'dhx_generated_class_u1545128180056'
            }
          );
          let empdata14 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.paythroughdt == 'null' || a.paythroughdt == 'undefined' || a.paythroughdt == undefined || a.paythroughdt == null ? '' : a.paythroughdt || a.paythroughdt == isNaN ? '' : a.paythroughdt),
            'code': 'paythroughdt',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata14);
          indexalphabet++;

          dataemployee.push({
            'cell': 'A' + (index),
            'value': '' + (a.fullName == 'null' || a.fullName == 'undefined' || a.fullName == undefined || a.fullName == null ? '' : a.fullName),
            'code': 'empId',
            'empId': a.emp_id
          });
          lockList.push('A' + (index))

        } else {
          let empdata1 = {
            'cell': 'A' + (index),
            'value': '' + (a.fullName == 'null' || a.fullName == 'undefined' || a.fullName == undefined || a.fullName == null ? '' : a.fullName),
            'code': 'empId',
            'empId': a.emp_id
          };
          lockList.push('A' + (index))
          dataemployee.push(empdata1);

          // let empdata3 = { "cell": idOf(indexalphabet + 1) + "" + (index + 1), "value": "" + a.bank_code.value, "code": "bank_code" };
          let empdata3 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.bank_code == 'null' || a.bank_code == 'undefined' || a.bank_code == undefined || a.bank_code == null ? '' : a.bank_code),
            'code': 'bank_code',
            'empId': a.emp_id
          };
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          dataemployee.push(empdata3);
          indexalphabet++;

          // let empdata4 = { "cell": idOf(indexalphabet + 1) + "" + (index + 1), "value": "" + a.bank_account.value, "code": "bank_account" };
          let empdata4 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.bank_account == 'null' || a.bank_account == 'undefined' || a.bank_account == undefined || a.bank_account == null ? '' : a.bank_account),
            'code': 'bank_account',
            'empId': a.emp_id
          };
          dataemployee.push(empdata4);
          indexalphabet++;

          // let empdata5 = { "cell": idOf(indexalphabet + 1) + "" + (index + 1), "value": "" + a.account_name.value, "code": "account_name" };
          let empdata5 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.account_name == 'null' || a.account_name == 'undefined' || a.account_name == undefined || a.account_name == null ? '' : a.account_name),
            'code': 'account_name',
            'empId': a.emp_id
          };
          dataemployee.push(empdata5);
          indexalphabet++;

          // let empdata6 = { "cell": idOf(indexalphabet + 1) + "" + (index + 1), "value": "" + a.bpjs.value, "code": "bpjs" };
          let empdata6 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.bpjs == 'null' || a.bpjs == 'undefined' || a.bpjs == undefined || a.bpjs == null ? '' : a.bpjs),
            'code': 'bpjs',
            'empId': a.emp_id
          };
          dataemployee.push(empdata6);
          indexalphabet++;

          // let empdata7 = { "cell": idOf(indexalphabet + 1) + "" + (index + 1), "value": "" + a.jamsostek.value, "code": "jamsostek" };
          let empdata7 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.jamsostek == 'null' || a.jamsostek == 'undefined' || a.jamsostek == undefined || a.jamsostek == null ? '' : a.jamsostek),
            'code': 'jamsostek',
            'empId': a.emp_id
          };
          dataemployee.push(empdata7);
          indexalphabet++;

          // let empdata8 = { "cell": idOf(indexalphabet + 1) + "" + (index + 1), "value": "" + a.taxfilenumber.value, "code": "npwp" };
          let empdata8 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.taxfilenumber == 'null' || a.taxfilenumber == 'undefined' || a.taxfilenumber == undefined || a.taxfilenumber == null ? '' : a.taxfilenumber),
            'code': 'taxfilenumber',
            'empId': a.emp_id
          };
          dataemployee.push(empdata8);
          indexalphabet++;

          // let empdata9 = { "cell": idOf(indexalphabet + 1) + "" + (index + 1), "value": "" + a.tax_type.value == 'L' ? 'Local' : a.tax_type.value == 'E' ? 'Expatriate' : '', "code": "tax_type" };
          let empdata9 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.tax_type == 'null' || a.tax_type == 'undefined' || a.tax_type == undefined || a.tax_type == null ? '' : a.tax_type),
            'code': 'tax_type',
            'empId': a.emp_id
          };
          dataemployee.push(empdata9);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          indexalphabet++;

          // let empdata10 = { "cell": idOf(indexalphabet + 1) + "" + (index + 1), "value": "" + a.taxstatus.value, "code": "tax_type" };
          let empdata10 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + ((a.taxstatus == 1 ? 'K' : 'TK') + (a.numdependent ? a.numdependent : 0)),
            'code': 'taxstatus',
            'empId': a.emp_id
          };
          dataemployee.push(empdata10);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          indexalphabet++;

          if (param == 0) {
            let empdata20 = {
              'cell': idOf(indexalphabet + 1) + '' + (index),
              'css': 'black',
              'value': '' +
                (a.taxbornebycompDec == 'null' || a.taxbornebycompDec == 'undefined'
                || a.taxbornebycompDec == undefined || a.taxbornebycompDec == null ? '' : a.taxbornebycompDec),
              'code': 'taxbornebycompDec',
              'empId': a.emp_id
            };
            dataemployee.push(empdata20);
            // lockList.push(idOf(indexalphabet + 1) + "" + (index))
            indexalphabet++;
          }

          let empdata11 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.tk == 'null' || a.tk == 'undefined' || a.tk == undefined || a.tk == null ? '' : a.tk),
            'code': 'tk',
            'empId': a.emp_id
          };
          dataemployee.push(empdata11);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          indexalphabet++;

          empdata11 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.saljht == 'null' || a.saljht == 'undefined' || a.saljht == undefined || a.saljht == null ? '' : a.saljht),
            'code': 'saljht',
            'empId': a.emp_id
          };
          dataemployee.push(empdata11);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          indexalphabet++;

          let empdata12 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.jp == 'null' || a.jp == 'undefined' || a.jp == undefined || a.jp == null ? '' : a.jp),
            'code': 'jp',
            'empId': a.emp_id
          };
          dataemployee.push(empdata12);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          indexalphabet++;

          empdata12 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.saljp == 'null' || a.saljp == 'undefined' || a.saljp == undefined || a.saljp == null ? '' : a.saljp),
            'code': 'saljp',
            'empId': a.emp_id
          };
          dataemployee.push(empdata12);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          indexalphabet++;

          let empdata13 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.ks == 'null' || a.ks == 'undefined' || a.ks == undefined || a.ks == null ? '' : a.ks),
            'code': 'ks',
            'empId': a.emp_id
          };
          dataemployee.push(empdata13);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          indexalphabet++;

          empdata13 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.salks == 'null' || a.salks == 'undefined' || a.salks == undefined || a.salks == null ? '' : a.salks),
            'code': 'salks',
            'empId': a.emp_id
          };
          dataemployee.push(empdata13);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))
          indexalphabet++;

          let empdata14 = {
            'cell': idOf(indexalphabet + 1) + '' + (index),
            'css': 'black',
            'value': '' + (a.paythroughdt == 'null' || a.paythroughdt == 'undefined' || a.paythroughdt == undefined || a.paythroughdt == null ? '' : a.paythroughdt),
            'code': 'paythroughdt',
            'empId': a.emp_id
          };
          dataemployee.push(empdata14);
          lockList.push(idOf(indexalphabet + 1) + '' + (index))

        }

      }
      let dataParse = {
        'data': dataemployee,
        'styles': this.excelStyles
      }

      let returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      }

      res(returnData)
    })
  }

  public getEmpPayrollDataMY(result): Promise<any> {
    return new Promise(res => {
      let index = 0;
      const dataemployee = [];
      const lockList = [];
      const headerList = [{
        value: '',
        css: '',
      }];

      // headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'});

      // LOOP PAYROLL INFO
      for (const a of result.detail) {

        index++;
        let indexalphabet: number = 0;

        if (index == 1) {

          for (const b of result.header) {
            if (b.type !== 'hidden') {
              headerList.push({
                value: b.label,
                css: 'dhx_generated_class_u1545128180056'
              });
              if (
                b.type === 'viewonly' ||
                b.type === 'date' ||
                b.type === 'locked' ||
                b.type === 'dropdown' ||
                b.type === 'yesno'
              ) lockList.push(this.idOf(indexalphabet) + '' + (index));

              dataemployee.push({
                cell: this.idOf(indexalphabet) + '' + (index),
                ...(b.code != 'fullName' && {css: 'black'}),
                value: '' + (a[b.code] == 'null' || a[b.code] == 'undefined' || a[b.code] == undefined || a[b.code] == null ? '' : a[b.code]),
                code: b.code,
                empId: a.emp_id
              });

              indexalphabet++;
            }
          }

        } else {

          for (const b of result.header) {
            if (b.type !== 'hidden') {
              if (
                b.type === 'viewonly' ||
                b.type === 'date' ||
                b.type === 'locked' ||
                b.type === 'dropdown' ||
                b.type === 'yesno'
              ) lockList.push(this.idOf(indexalphabet) + '' + (index));

              dataemployee.push({
                cell: this.idOf(indexalphabet) + '' + (index),
                ...(b.code != 'fullName' && {css: 'black'}),
                value: '' + (a[b.code] == 'null' || a[b.code] == 'undefined' || a[b.code] == undefined || a[b.code] == null ? '' : a[b.code]),
                code: b.code,
                empId: a.emp_id
              });

              indexalphabet++;
            }
          }

        }
      }

      const dataParse = {
        data: dataemployee,
        styles: this.excelStyles,
      };

      const returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      };

      res(returnData)
    })
  }

  public getEmpTaxDeductionMY(result): Promise<any> {
    return new Promise((res) => {
      let index = 0;
      const dataemployee = [];
      const lockList = [];
      const headerList = [{
        value: '',
        css: '',
      }];

      // result.sort((a, b) => (a.emp_id == null ? '' : a.emp_id).localeCompare(b.emp_id == null ? '' : b.emp_id));

      headerList.push({value: this.translate.instant('Employee'), css: 'dhx_generated_class_u1545128180056'});
      lockList.push('A1');

      for (let a of result) {
        index++;
        let indexalphabet = 0;
        if (index == 1) {

          for (let comp of a.listTaxDeduct) {

            headerList.push({value: '' + comp.name, css: 'dhx_generated_class_u1545128180056'});

            dataemployee.push({
              cell: this.idOf(indexalphabet + 1) + '' + (index),
              css: comp.taxfieldtype == 'MONEY' ? 'number-black' : 'black',
              value: '' +
              comp.taxfieldtype == 'MONEY' ?
                this.transformer((comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value)) :
                comp.taxfieldtype == 'NUMBER' ?
                  this.convertToNumber((comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value)) :
                  (comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value),
              code: '' + comp.code,
              empId: {empId: a.emp_id, taxfieldtype: comp.taxfieldtype},
            });

            if (
              comp.taxfieldtype == 'OPTIONS' ||
              comp.taxfieldtype == 'YESNO' ||
              comp.taxfieldtype == 'DATE'
            ) lockList.push(this.idOf(indexalphabet + 1) + '' + (index));
            indexalphabet++;

          }

          dataemployee.push({'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id});
          lockList.push('A' + (index))

        } else {

          dataemployee.push({'cell': 'A' + (index), 'value': '' + a.fullName, 'code': 'empId', 'empId': a.emp_id});
          lockList.push('A' + (index))

          for (let comp of a.listTaxDeduct) {

            dataemployee.push({
              cell: this.idOf(indexalphabet + 1) + '' + (index),
              css: comp.taxfieldtype == 'MONEY' ? 'number-black' : 'black',
              value: '' +
              comp.taxfieldtype == 'MONEY' ?
                this.transformer((comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value)) :
                comp.taxfieldtype == 'NUMBER' ?
                  this.convertToNumber((comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value)) :
                  (comp.value == 'null' || comp.value == 'undefined' || comp.value == undefined || comp.value == null ? '' : comp.value),
              code: '' + comp.code,
              empId: {empId: a.emp_id, taxfieldtype: comp.taxfieldtype},
            });

            if (
              comp.taxfieldtype == 'OPTIONS' ||
              comp.taxfieldtype == 'YESNO' ||
              comp.taxfieldtype == 'DATE'
            ) lockList.push(this.idOf(indexalphabet + 1) + '' + (index));
            indexalphabet++;

          }
        }
      }

      const dataParse = {
        'data': dataemployee,
        'styles': this.excelStyles,
      };

      const returnData = {
        dataParse: dataParse,
        lockList: lockList,
        headerList: headerList,
      };

      res(returnData);
    })
  }

  private transformer(value: string, fractionSize: number = 2) {
    value = value.toString().replace(/,/g, '').replace(/^0+/, '');
    let DECIMAL_SEPARATOR = '.';
    let THOUSANDS_SEPARATOR = ',';
    let PADDING = '000000';
    let PREFIX = ''
    if (this.isNumeric(value)) {
      let [integer, fraction = ''] = (value || '').toString().split('.');
      fraction = fractionSize > 0 ? DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize) : '';
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, THOUSANDS_SEPARATOR);
      return PREFIX + integer + fraction;
    } else {
      return 0;
    }
  }

  private isNumeric(value: any): boolean {
    return !isNaN(value - parseFloat(value));
  }

  private converToNumber(x: any): string {
    if (this.isNumeric(x)) {
      return Number(x).toLocaleString();
    } else {
      return '0';
    }
  }

  private convertToNumber(x: any): string {
    if (this.isNumeric(x)) {
      return Number(x).toLocaleString();
    } else {
      return '0';
    }
  }

  private idOf(i) {
    return (i >= 26 ? this.idOf((i / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[i % 26 >> 0];
  }
}



// WEBPACK FOOTER //
// ./src/providers/gd-payroll/gd-payroll.ts